<template>
  <div class="news">
    <!-- <div class="header">
      <div
        class="item"
        v-for="item in titleList"
        :key="item.id"
        :class="titleId == item.id ? 'active' : ''"
        @click="clickTab()"
      >
        <div>{{ item.title }}</div>
      </div>
    </div> -->

    <div class="body">
      <div class="left">
        <div class="list">
          <div class="item" v-for="item in newsList" :key="item.id">
            <div class="box" v-if="item.id == newsId">
              <div class="title">{{ item.title }}</div>
              <div class="flex">
                <div class="date">
                  <img :src="timer" alt="" />
                  <div>{{ item.date }}</div>
                </div>
                <div class="source">来源：{{ item.source }}</div>
              </div>
              <img class="logo" :src="item.logo" alt="" />
              <div class="text">{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>

      <DynamicRight></DynamicRight>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import DynamicRight from "../../../components/pc/Dynamic/DynamicRight.vue";

import newsdetails1 from "../../../assets/dynamic/newsdetails1.png";
import newsdetails2 from "../../../assets/dynamic/newsdetails2.png";
import newsdetails3 from "../../../assets/dynamic/newsdetails3.png";
import newsdetails4 from "../../../assets/dynamic/newsdetails4.png";
import newsdetails5 from "../../../assets/dynamic/newsdetails5.png";

import timer from "../../../assets/dynamic/timer.png";

import more from "../../../assets/dynamic/more.png";

export default {
  props: ["newsId"],
  setup() {
    return reactive({
      more: more,
      demoShow: false,
      titleId: 1,
      titleList: [
        {
          id: 1,
          title: "行业新闻",
        },
        {
          id: 2,
          title: "公司动态",
        },
      ],
      newsList: [
        {
          id: 0,
          title: "传统物业与现在的智慧物业相比，智慧物业管理系统有哪些优势？",
          text: "智慧物业是利用互联网等高科技手段，让普通物业管理模式变得更加智能化。其实，好的智慧物业离我们的生活还很遥远，但是使用智慧物业管理系统可以在一定程度上形成智慧物业模式。智慧物业管理系统的优势在于可以提升物业管理人员的工作效率和业主的生活质量。传统物业管理的缺点：1、人工成本高：物业服务的本质决定了其价值应该通过人来实现。传统物业管理在收费、访客登记、数据统计等日常工作场景中主要依靠大量人力。不仅耗费大量人力，而且效率低下，容易出错。2、服务工作效率低：业主报事报修需要到物业办公室或电话进行人工指令，物业工作人员不明原因导致处理速度慢、进度难以跟踪、无法落实处理结果，严重影响物业服务的效率和服务水平。3、物业费收缴率低：传统的物业管理模式对于费用账单的统计不够方便，需要物业张贴缴费清单、上门催缴等，工作量大，收缴率低，费用明细不清，交费繁琐，导致业主容易出现拒缴的情况。4、设备和设施管理的成本高：物业的车禁、门禁、管理软件由不同厂家提供，相互兼容性差，后续平台升级维护困难且成本高；人工统计设备数量，将设备信息记录在纸面上，既费时又费钱。5、信息化程度低：硬件设备的互联互通是信息化的重要内容，传统物业管理没有集物业管理、移动OA、业主服务、便民服务于一体的一站式管理服务平台，无法共享数据，容易造成信息孤岛。与传统物业相比，智能物业管理系统有哪些优势？1、智慧物业管理系统推动智慧城市发展。之前说过，现在是一个信息化时代，也是一个用大数据说话的时代。智慧物业管理系统也是智慧城市建设的中心环节。不仅方便了大家的生活，也提高了大家的生活质量。2、智能物业管理系统提高了物业管理人员的工作效率和质量。众所周知，在传统物业小区，如果你需要找物品，做一些事情，比如维修服务，付款等。你需要自己跑一趟。但是有了智慧物业管理系统，就可以直接实现再在线缴费，在线报修等，非常方便。而且物业管理人员也能在系统上看到你的需求，能及时为你处理你的问题。3、促进了业主与物业公司、业主与业主之间的沟通。众所周知，在传统物业中，只有物业经理和业主可以沟通，但业主之间的沟通可能会少很多。引入智慧物业管理系统后，这个平台是完全开放的，业主也可以在上面交流自己的想法，也可以促进物业公司的管理。客户通智慧物业管理系统主要功能模块有：缴费收费、工单报修、资产管理、客户管理等，舆情管理等。发现疫情，一键上报有居民发现疫情相关或重大事件，可通过在互通群中输入《疫情上报》获取居民上报入口，进行事件上报。管家在工作台疫情上报入口也可直接上报。物业费微信批量催费每个月系统会自动生成帐单，如果逾期未缴的，系统会自动生成催费任务，催费任务发送给管家，管家一键进行发送业主进行催费处理。业主打开链接直接缴费，自动发送缴费清单与明细。自动生成账单在线缴费自动生成账单，业主通过微信公众号及小程序可自行查看到费 用明细。线上支付⸺随时随地便捷缴费；缴费后系统自动推送 电子收据明细。数据透明，有据可查，更省心，更放心。投诉、报事报修督导流程业主线上直接报事/报修，工单直接推送到作业人员，消息推送，实时提醒。缴费场景多样化全通道收费，采用多种收费方式，全面覆盖收费缴费场景，通过微信线上通道，满足业主缴费多样支付场景。收费管理支持按面积/套数/楼层/用量计费、接替价、一表多费，多种分摊方式，达到即可因体立格，亦可量体裁衣月度抄表、预存账户管理、应收账单管理、交易记录账单、流水记得清清楚楚支持微信代扣、预存抵扣，免去逐一手动收费的麻烦，支持在线缴费、扫码缴费等多种业务便捷缴费。客户通智慧物业管理系统由企业微信与客户通科技联合打造的物业行业解决方案，一个APP(企微)，解决所有问题，管家只需要用到一个企业微信，业主只需要用到个人微信即可。业主使用简易便捷，物业公司落地更有效果，助力行业数字化转型升级，改变传统服务模式，降低物业服务成本，改变业主生活体验，推动社区生活方式的蝶变。",
          logo: newsdetails1,
          date: "2022-07-05",
          source: "客户通科技",
        },
        {
          id: 1,
          title: "10大物业管理软件排名",
          text: "排名或者榜单之类应该由行业权威部门来弄的，如题，从来没有国家或行业权威对物业管理软件进行过相关排名，所以，物业软件排名根本没有标准答案，适合的就是好的。根据公司功能需求和预算，选择合适的软件即可。目前市场上的物业管理软件很多，推荐使用“小红马”智慧社区物业管理软件，此款软件自上线以来一直备受广大用户欢迎，口碑也相当不错。“小红马”智慧社区的独特优势：1、业主无需下载APP，只需要关注微信小程序和公众号。2、智能硬件一站式管理，并及时更新对接最新的智能硬件。包括：人脸门禁、智能停车、人脸监控、汽车充电桩、电动充电桩、电动车梯阻系统，智能公共用电系统等。3、完善的多经工具包，小程序包含周边店铺、外卖、家政、跑腿、团购、商城等。（区别于其他软件只有商城模式），配套砍价，直播，短视频、直播等最新的营销工具。4、插件式功能模块，页面内容和功能模块可以个性化定制，让业主更有归属感。也可以根据项目需求个性化定制功能。5、专业的物业多种经营运营团队，全程托管式赋能社区商业运营，助力对社区的有效经营变现。“小红马”智慧社区能给物业带来什么？让物业工作省时省力，提高人效，节约成本；服务痕迹数据化留存，物业工作更清晰，减少失误。助力物业收费率提升，助力物业服务品质提升，提高业主满意度，多方式赋能物业实现多种经营收益，携手企业微信助力物业转型等。“小红马”社会价值：1、满足人民群众不断增长的美好居住生活需要2、孵化优质社区服务企业，解决社区周边就业3、促进物业企业，政府基层管理信息化，移动化、无纸化、节能高效",
          logo: newsdetails2,
          date: "2022-07-04",
          source: "客户通科技",
        },
        {
          id: 2,
          title: "智慧物业管理系统建设智慧社区为何这么受欢迎？",
          text: "近几年信息技术飞速发展，数字化产品也逐渐呈现在人们眼前，各种智能机器人、智能检测体温设备、无人机驾驶汽车的出现都让大家感受到科技给生活带来的便利。在这样的科技大环境下，智慧社区也加入了其中，从信息化管理到智能设备建设，给社区生活带来了新的体验方式。社区数字化的实现能够为社区提供更加便捷的物业服务，解决了物业费缴纳、报事报修、在线咨询等问题，大幅提高了社区生活的便利性。社区智能化建设提升了社区的安全性、便捷性，帮助社区监控系统、智能门禁系统实现了智能化。以智能门禁为例，严格管理社区出入口，禁止社区以外的人员随意进出，做到来访信息留档，加强社区的安全性。同时智能门禁提供多种开门方式，既可以人脸识别开门，也可以手机APP开门、刷卡开门，社区居民进出社区既安全又便捷。此外，智能系统还实时监控着社区的各个角落，一旦发现异常，社区的智能大屏就会有显示，并发出相应警报。智慧社区为什么会受到大家的青睐呢？在物业服务方面，用户可享受在线服务，不必像以前一样需要前往服务中心办理，整个过程变得更加轻松和便利。以往的社区相对比较封闭，在智慧社区中邻里交友更加便捷，能够将生活中的美好事物分享到邻里圈。在社区设备方面，安全性和便捷性也得到了大幅提升，在使用过程中也变得更加灵活、顺手。客户通智慧物业管理系统主要功能模块有：缴费收费、工单报修、资产管理、客户管理等，舆情管理等。发现疫情，一键上报有居民发现疫情相关或重大事件，可通过在互通群中输入《疫情上报》获取居民上报入口，进行事件上报。管家在工作台疫情上报入口也可直接上报。微信批量催费每个月系统会自动生成帐单，如果逾期未缴的，系统会自动生成催费任务，催费任务发送给管家，管家一键进行发送业主进行催费处理。业主打开链接直接缴费，自动发送缴费清单与电子发票。自动生成账单在线缴费自动生成账单，业主通过微信公众号及小程序可自行查看到费 用明细。线上支付⸺随时随地便捷缴费；缴费后系统自动推送 电子收据及发票。数据透明，有据可查，更省心，更放心。投诉、报事报修督导流程业主线上直接报事/报修，工单直接推送到作业人员，消息推送，实时提醒。缴费场景多样化全通道收费，采用多种收费方式，全面覆盖收费缴费场景，通过微信线上通道，满足业主缴费多样支付场景。收费管理支持按面积/套数/楼层/用量计费、接替价、一表多费，多种分摊方式，达到即可因体立格，亦可量体裁衣月度抄表、预存账户管理、应收账单管理、交易记录账单、流水记得清清楚楚支持微信代扣、预存抵扣，免去逐一手动收费的麻烦，支持在线缴费、扫码缴费等等等多种业务便捷缴费收费管理智能化通过统一的收费系统后台，业主实时缴费实时记录，保证基础数据收集简单化、准确性高；实现任何场景的支付缴费走线上程序，全面实现实时入账、简单对账、账实相符，减少账实不符出现的问题；系统联动性减轻物业人员收费管理对账压力，减少人工查账与核对数据的大量工作，降低物业公司人力成本支出，提高管理与服务效率。客户通智慧社区解决方案由企业微信与客户通科技联合打造的物业行业解决方案，一个APP(企微)，解决所有问题，管家只需要用到一个企业微信，业主只需要用到个人微信即可。业主使用简易便捷，物业公司落地更有效果，助力行业数字化转型升级，改变传统服务模式，降低物业服务成本，改变业主生活体验，推动社区生活方式的蝶变。随着时代的不断发展和进步，智慧社区未来的还具有很大的发展潜力，也会有更多的智慧化项目被开发出来，因此智慧社区受到越来越多人的关注和青睐，为人们的生活提供更多便利。",
          logo: newsdetails3,
          date: "2022-06-28",
          source: "客户通科技",
        },
        {
          id: 3,
          title: "疫情之下，智慧物业管理系统的建设，有了更多的“用武之地”。",
          text: "疫情以来，随着社区站在外防内防扩散的第一线，物业服务企业的精准排查、消防消杀、严格门禁、提供上门服务等能力也得到检验。根据2020年3月中国物业管理协会联合中国经济信息社开展的“新冠肺炎疫情对物业管理行业影响专项调查”，在36450份业主问卷中，89.88%受访业主认为物业管理在社区疫情联防联控体系中非常重要，认为比较重要的业主占比为8.09%。在物业管理能力受到关注的同时，依托人工智能、大数据、物联网等新技术的智慧物业也成为很多小区“科学防疫”的手段。疫情之下，智能化、自动化的物业设施有了更多的“用武之地”。除了加速智慧物业向社区渗透，相关的讨论也一直没有停止。比如疫情检测出了当下智慧物业的哪些痛点？智慧物业是不是所有小区的“标配”？一系列问题促使智慧财产探索标准化和专业化的道路。近年来，物业管理水平日益提高的同时，也面临着过度依赖人员、物业成本高、压力大等极待优化解决的问题。通过智慧物业管家系统，帮助物业管理企业加速实现小区物业信息化管理，提供基于影像监测分析、人工智能识别技术等智慧物业服务，实现社区服务数字化管理、社区安防智能管理、小区停车规范化管理等。从而降本增效，提升业主服务满意度，构建可持续发展的物业服务生态圈。智慧物业管理系统通过一个平台解决智能安防、智能管理、智能服务等物业管理的整体业务。智能监控基于图像监控分析和人工智能识别技术，对小区物业管理人员、宠物、外来人员、车辆进行监控跟踪，对异常事件进行预警，实现智能安防的数字化管理，提高小区人员安全管理效率和异常事件的响应和处理速度。智能管理告别纸质办公，实现随时随地的物业管理，实现资产管理、租赁管理、设备管理、财务管理、房屋维护等关键物业管理的IT化、智能化，大幅提升物业管理效率，降本增效。智能服务基于物联网、互联网等技术，提供远程门锁解锁、智能水表、烟雾报警、在线等智能物业管理网络，自动生成缴费/提醒任务。业主可以随时随地在线缴费、报修、开门，提高服务满意度和物业费收缴率。智慧物业管理系统典型应用场景：物业管理人员的数字化管理实时监控物业管理人员的值班巡逻，实时跟踪物业人员的活动轨迹，预警物业人员的违规/破坏行为，加强对物业管理人员的管理。社区安全智能管理实时监控小区外来人员的情况，对外来人员的异常行为进行智能报警，实时跟踪外来人员的活动轨迹，提高小区人员和财产的安全性。社区停车的规范化管理对进入小区的车辆进行实时监控，对车辆违章和异常事故进行智能预警，对事故监控进行巡查，对突发事件做出快速反应，减少因管理漏洞造成的损失和事故纠纷。社区物业信息管理实现关键物业管理的IT化、智能化，随时随地管理物业。不再局限于办公室、智能水电表等智能物业管理网络，也不再需要在家抄表，实现一键智能抄表，自动生成缴费/提醒任务和提醒。在科技快速发展的推动下，智慧物业是未来物业管理的趋势。作为与人们生活工作联系最紧密的物业管理行业，依靠科技的力量，改变自身的思想观念，提高服务效率和质量，才能跟上人们生活方式的变化和日益增长的美好生活需求。客户通智慧物业管理系统主要功能模块有：缴费收费、工单报修、资产管理、客户管理等，舆情管理等。发现疫情，一键上报有居民发现疫情相关或重大事件，可通过在互通群中输入《疫情上报》获取居民上报入口，进行事件上报。管家在工作台疫情上报入口也可直接上报。物业费微信批量催费每个月系统会自动生成帐单，如果逾期未缴的，系统会自动生成催费任务，催费任务发送给管家，管家一键进行发送业主进行催费处理。业主打开链接直接缴费，自动发送缴费清单与明细。自动生成账单在线缴费自动生成账单，业主通过微信公众号及小程序可自行查看到费 用明细。线上支付⸺随时随地便捷缴费；缴费后系统自动推送 电子收据明细。数据透明，有据可查，更省心，更放心。投诉、报事报修督导流程业主线上直接报事/报修，工单直接推送到作业人员，消息推送，实时提醒。缴费场景多样化全通道收费，采用多种收费方式，全面覆盖收费缴费场景，通过微信线上通道，满足业主缴费多样支付场景。收费管理支持按面积/套数/楼层/用量计费、接替价、一表多费，多种分摊方式，达到即可因体立格，亦可量体裁衣月度抄表、预存账户管理、应收账单管理、交易记录账单、流水记得清清楚楚支持微信代扣、预存抵扣，免去逐一手动收费的麻烦，支持在线缴费、扫码缴费等多种业务便捷缴费。",
          logo: newsdetails5,
          date: "2022-06-15",
          source: "客户通科技",
        },
        {
          id: 4,
          title: "智慧物业管理系统的建设如何解决传统物业管理的“痛点”？",
          text: "随着移动互联网技术的兴起，传统的物业管理行业正在悄然转型。出门忘带门禁、楼道设备坏了不知道找谁维修、出差在外忘记缴纳物业费等等。智慧物业管理系统平台的建设解决了传统物业管理的“痛点”。听到“智慧物业”这个名字，你首先想到的可能是智能社区、智能管家这类应用，其实，智慧物业是指利用大数据、物联网等先进的信息技术手段，通过统一的大数据云平台，将物业的各个单位紧密连接起来，从而实现物业单位的数据融合。此外，通过对融合数据的深入分析和挖掘，可以发现物业管理中的各方面问题，突破部门之间的沟通障碍，建立高效的联动机制，从而有效、快速地解决物业管理中的各方面问题。要想有效应对处理物业管理存在的问题，一方面要通过完善政策法规，提高物业管理的法制化、规范化水平；另一方面，要积极运用新技术、新理念，实施“互联网加物业”的新型管理模式。客户通智慧社区管理系统将推动物业管理向信息化、智能化转型，通过信息资源共享，加速物业服务的规范化、市场化。移动互联网时代，线上线下服务日益融合。发展智慧物业是物业服务企业的发展方向和趋势，既能提高物业管理水平，又能提升业主满意度。智慧物业SAAS系统的建设为推进智慧社区和智慧城市建设提供了有力支撑。智慧物业的特点和优势总的来说，与传统的物业管理模式相比，智慧物业具有非常显著的优势：一、它有效地提高了物业管理的效率和质量。通过物业管理基础信息的数字化整合、共享和使用，可以使行政主管部门清晰直观地了解物业服务公司运转状况，对标准行业规则、促进物业服务行业诚信体系建造、优化公司内部管理起到了非常积极有效的作用。二、有效促进了业主与物业服务企业之间沟通平台的建立。互联网的使用为业主表达意见提供了便捷高效的途径，过程更加公开透明。同时，业主还可以通过小程序公众号对物业提供改进建议，评价物业服务。物业服务公司可以在线及时处理业主需求，提升物业公司形象和客户满意度。三、推动了社区商业圈的经济发展，可以加强社区周边商业资源信息的整合、共享和利用，进行精准广告宣传，更好地满足居民需求和商家供给，促进社区O2O消费、快递服务等新业态发展。四、大力推进智慧城市建设，智慧社区是智慧城市建设的主要基础和关键环节。物业管理将通过数字化和信息化平台进行全面升级，使社区可以更方便地连接到智慧城市的平台上，智慧物业可以帮助物业公司提高管理效率，降低成本，帮助传统物业公司快速转型，从长远来看也是大势所趋。客户通智慧物业管理系统主要功能模块有：缴费收费、工单报修、资产管理、客户管理等，舆情管理等。发现疫情，一键上报有居民发现疫情相关或重大事件，可通过在互通群中输入《疫情上报》获取居民上报入口，进行事件上报。管家在工作台疫情上报入口也可直接上报。物业费微信批量催费每个月系统会自动生成帐单，如果逾期未缴的，系统会自动生成催费任务，催费任务发送给管家，管家一键进行发送业主进行催费处理。业主打开链接直接缴费，自动发送缴费清单与明细。自动生成账单在线缴费自动生成账单，业主通过微信公众号及小程序可自行查看到费 用明细。线上支付⸺随时随地便捷缴费；缴费后系统自动推送 电子收据明细。数据透明，有据可查，更省心，更放心。投诉、报事报修督导流程业主线上直接报事/报修，工单直接推送到作业人员，消息推送，实时提醒。缴费场景多样化全通道收费，采用多种收费方式，全面覆盖收费缴费场景，通过微信线上通道，满足业主缴费多样支付场景。收费管理支持按面积/套数/楼层/用量计费、接替价、一表多费，多种分摊方式，达到即可因体立格，亦可量体裁衣月度抄表、预存账户管理、应收账单管理、交易记录账单、流水记得清清楚楚支持微信代扣、预存抵扣，免去逐一手动收费的麻烦，支持在线缴费、扫码缴费等多种业务便捷缴费。客户通智慧物业管理系统由企业微信与客户通科技联合打造的物业行业解决方案，一个APP(企微)，解决所有问题，管家只需要用到一个企业微信，业主只需要用到个人微信即可。业主使用简易便捷，物业公司落地更有效果，助力行业数字化转型升级，改变传统服务模式，降低物业服务成本，改变业主生活体验，推动社区生活方式的蝶变。",
          logo: newsdetails4,
          date: "2022-06-09",
          source: "客户通科技",
        },
      ],
      timer: timer,
    });
  },
  components: {
    DynamicRight,
  },
  methods: {
    clickTab() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.news {
  width: 1180px;
  margin: 80px auto 190px;
}

.header {
  display: flex;
  border-bottom: 1px solid #dce1e8;
}
.header .item {
  padding: 40px 0;
  margin-right: 50px;
  font-size: 30px;
  cursor: pointer;
}
.header .active {
  border-bottom: 5px solid #248efb;
  color: #248efb;
}

.body {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
}
.body .left {
  width: 780px;
}
.body .left .list .item .box .title {
  font-size: 20px;
  color: #333;
}
.body .left .list .item .box .flex {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #dce1e8;
}
.source {
  margin-left: 40px;
  font-size: 12px;
  color: #6f8398;
}
.body .left .list .item .box .flex .date {
  display: flex;
  align-items: center;
}
.body .left .list .item .box .date img {
  width: 18px;
  margin-right: 10px;
}
.body .left .list .item .box .date div {
  font-size: 12px;
  color: #6f8398;
}
.body .left .list .item .box .logo {
  width: 780px;
  margin-top: 40px;
}
.body .left .list .item .box .text {
  font-size: 14px;
  color: #3d3d3d;
  margin-top: 20px;
}
</style>
